export enum PaginationTypeEnum {
  INFINITE_SCROLL = "INFINITE_SCROLL",
  PAGINATION = "PAGINATION",
}
